import Vue from 'vue';
import router from './router';
import vuetify from './plugins/vuetify';
import App from './App.vue';
// import { VueReCaptcha } from 'vue-recaptcha-v3';

// Vue.use(VueReCaptcha, { siteKey: '6LejctwUAAAAAA6skeToMzeAqLVNPEMJSIZP3cOn' });
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
